// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8837874d","431":"836f1e4e","489":"81c83040","492":"8c10ba37","507":"02c2b987","608":"9bead10e","787":"dab391eb"}[chunkId] + ".chunk.js";
};